<div class="content-wrapper_margin">
  <div class="order">
    <div class="container">
      <h1 class="main-title">{{'ORDER.order' | translate }}</h1>
      <app-order-form></app-order-form>
    </div>
  </div>
</div>
